export default __webpack_public_path__ + "static/media/pending-consent-icon.f94b85b8.png";